<script setup lang="ts">
import { useAlphabetList } from '../composables/useAlphabetList';

/**
 * Alphabetische Filterkomponente
 * Zeigt Buchstaben-Filter mit Verfügbarkeitsstatus
 */

interface LetterItem {
  letter: string;
  hasItems: boolean;
}

const props = defineProps<{
  letters: LetterItem[];
  selectedLetter: string;
}>();

const emit = defineEmits<{
  (e: 'select-letter', letter: string): void;
}>();

const {
  onSelect,
  getLetterClasses
} = useAlphabetList(props, emit);
</script>

<template>
  <div class="row">
    <div class="col-12 filter-alphabet">
      <div>
        <span
            v-for="item in letters"
            :key="item.letter"
            :class="getLetterClasses(item)"
            @click="onSelect(item)"
        >
          {{ item.letter }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>